/** Сводка рейтинга товара (`ShowcaseReviewSummaryDto`): только нужные для SEO поля */
interface ReviewsSummaryLike {
  rating?: number | null
  count: number
}

/** Опубликованный отзыв (`ShowcaseReviewDto`): только нужные для SEO поля */
interface PublicReviewLike {
  authorName: string
  rating: number
  pros?: string | null
  cons?: string | null
  text?: string | null
  date: string
}

/** Рейтинг и отзывы для `productJsonLd` (модуль Seo) */
export interface ReviewsSeoOpts {
  rating?: { value: number, count: number }
  reviews?: { author: string, rating: number, body?: string, date: string }[]
}

/**
 * Рейтинг и первые отзывы товара → опции JSON-LD (`aggregateRating` и `review`).
 * Разметка рейтинга — только при `count > 0` и известной средней: schema.org требует
 * `ratingValue`, а рейтинг без отзывов поисковики считают ошибкой. Текст отзыва —
 * достоинства, недостатки и комментарий через перевод строки; отзыв из одной оценки — без текста.
 */
export function reviewsSeoOpts(
  summary: ReviewsSummaryLike | null | undefined,
  top: PublicReviewLike[] | null | undefined,
): ReviewsSeoOpts {
  if (!summary || summary.count <= 0) return {}
  if (typeof summary.rating !== 'number' || Number.isNaN(summary.rating)) return {}

  const opts: ReviewsSeoOpts = { rating: { value: summary.rating, count: summary.count } }
  if (top?.length) {
    opts.reviews = top.map(r => ({
      author: r.authorName,
      rating: r.rating,
      body: [r.pros, r.cons, r.text].map(part => part?.trim()).filter(Boolean).join('\n') || undefined,
      date: r.date,
    }))
  }
  return opts
}
